import { FC, useCallback } from 'react';
import { Button } from 'tedooo-web-design-system/ui';

import { IShopActivitiesSection, IShopActivity, Sections } from 'types';
import Activity from './activity/Activity';
import Section from 'components/section/Section';
import { translations } from 'translations/en';

const ActivitiesSection: FC<IShopActivitiesSection> = ({
  list,
  isShopOwner,
  onEmptyStateButtonClick,
  onActivitiesClick,
  onActivityClick,
}) => {
  const itemContent = useCallback((item: IShopActivity) => {
    return (
      <Activity
        key={item.id}
        onActivityClick={onActivityClick}
        text={item.text}
        image={item.image}
        date={item.date}
        id={item.id}
        repostId={item.repostId}
      />
    );
  }, []);

  if (!list) {
    return null;
  }
  let emptyStateButton;
  if (isShopOwner) {
    emptyStateButton = (
      <Button
        type="primary"
        size="medium"
        borderRadius="small"
        onClick={onEmptyStateButtonClick}
        text={translations.SHOP.ACTIVITY_EMPTY_STATE_BUTTON}
      />
    );
  }

  return (
    <Section
      list={list}
      itemContent={itemContent}
      type={Sections.Activity}
      onButtonClick={onActivitiesClick}
      emptyStateButton={emptyStateButton}
    />
  );
};

export default ActivitiesSection;
